import "/app-src/app/javascript/modules/tooltips.js";
import "/app-src/app/javascript/modules/taggable.js.coffee";
import "/app-src/app/javascript/modules/subscriber_lists.js";
import "/app-src/app/javascript/modules/string_trim.js.coffee";
import "/app-src/app/javascript/modules/spinner.js.coffee";
import "/app-src/app/javascript/modules/remote_autocomplete.js";
import "/app-src/app/javascript/modules/profile_overlay.coffee";
import "/app-src/app/javascript/modules/popover_handler.js";
import "/app-src/app/javascript/modules/persistent_dropdown.js.coffee";
import "/app-src/app/javascript/modules/participation_lists.js";
import "/app-src/app/javascript/modules/on_page_load.js.coffee";
import "/app-src/app/javascript/modules/notes.js.coffee";
import "/app-src/app/javascript/modules/nav_off_canvas.js.coffee";
import "/app-src/app/javascript/modules/multiselect.js";
import "/app-src/app/javascript/modules/mailing_list_labels.js.coffee";
import "/app-src/app/javascript/modules/invoices.js.coffee";
import "/app-src/app/javascript/modules/invoice_message_template.js";
import "/app-src/app/javascript/modules/invoice_articles.js.coffee";
import "/app-src/app/javascript/modules/invitation_lists.js.coffee";
import "/app-src/app/javascript/modules/input_enabler.js.coffee";
import "/app-src/app/javascript/modules/help_texts.js.coffee";
import "/app-src/app/javascript/modules/filter_attribute.js.coffee";
import "/app-src/app/javascript/modules/event_kind_preconditions.js.coffee";
import "/app-src/app/javascript/modules/element_toggler.js.coffee";
import "/app-src/app/javascript/modules/element_swapper.js.coffee";
import "/app-src/app/javascript/modules/disabled_links.js.coffee";
import "/app-src/app/javascript/modules/datepicker.js";
import "/app-src/app/javascript/modules/copy_to_clipboard.js.coffee";
import "/app-src/app/javascript/modules/collapse_overflow_fix.js.coffee";
import "/app-src/app/javascript/modules/clickable_placeholders.js.coffee";
import "/app-src/app/javascript/modules/clear_input.js.coffee";
import "/app-src/app/javascript/modules/auto_submit.js.coffee";
import "/app-src/app/javascript/modules/ajax_replace.js.coffee";
import "/app-src/app/javascript/modules/ajax_error_notification.js.coffee";
import "/app-src/app/javascript/modules/people/toggle_household_for_labels.js";
import "/app-src/app/javascript/modules/people/people_filter_role_toggle.js.coffee";
import "/app-src/app/javascript/modules/people/people_filter_qualification_validity_toggle.js.coffee";
import "/app-src/app/javascript/modules/events/date_period_validator.js.coffee";
import "/app-src/app/javascript/modules/events/application_market.js.coffee";
import "/app-src/app/javascript/modules/contactables/contactable_address_field.js";